import React from "react";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? "bg-white/90 backdrop-blur-md py-4 shadow-sm" : "bg-transparent py-6"}`}>
      <div className="max-w-6xl mx-auto flex justify-between items-center p-4">
        {/* Logo and Tagline */}
        <div className="flex flex-col justify-left">
          <span className={`text-xl font-serif tracking-widest uppercase ${scrolled ? "text-blue-900" : "text-white"}`}>De Galapagos</span>
          <p className={`flex justify-end text-lg font-light italic ${scrolled ? "text-blue-900" : "text-white"}`}>Ama la vida</p>
        </div>
        <div className="hidden md:flex items-center gap-12">
          {["About", "Products", "Recipes", "Contact"].map((item) => (
            <a 
              key={item} 
              href={`#${item.toLowerCase().replace(" ", "-")}`} 
              className={`text-sm tracking-widest uppercase font-medium transition-colors ${scrolled ? "text-gray-600 hover:text-blue-900" : "text-white/80 hover:text-white"}`}
            >
              {item}
            </a>
          ))}
        </div>
        <button className="md:hidden text-white" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X className={scrolled ? "text-blue-900" : "text-white"} /> : <Menu className={scrolled ? "text-blue-900" : "text-white"} />}
        </button>
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="absolute top-full left-0 w-full bg-white shadow-xl py-8 flex flex-col items-center gap-6 md:hidden"
            >
              {["About", "Products", "Recipes", "Contact"].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase().replace(" ", "-")}`}
                  className="text-lg tracking-widest uppercase font-serif text-gray-800"
                  onClick={() => setIsOpen(false)}
                >
                  {item}
                </a>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      
    </nav>
  );
}

export default Navbar;
